import Vue from 'vue';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate';
import { numeric, required } from 'vee-validate/dist/rules';
import ptBR from 'vee-validate/dist/locale/pt_BR.json';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

extend('required', required);
extend('numeric', numeric);
localize('pt_BR', ptBR);
